export default __webpack_public_path__ + "static/media/toyarmy.18ad9fd3.png";